// @flow

import ButtonOutline from './ButtonOutline'

export default ButtonOutline
